import { Action, ActionReducer, MetaReducer } from "@ngrx/store";
import * as Sentry from "@sentry/angular";

const MAX_BREADCRUMB_DATA_LENGTH = 500;

function truncate(value: unknown): unknown {
	if (typeof value === "string" && value.length > MAX_BREADCRUMB_DATA_LENGTH) {
		return value.substring(0, MAX_BREADCRUMB_DATA_LENGTH) + "...[truncated]";
	}
	return value;
}

function isFailureAction(action: Action): boolean {
	return action.type.includes("Failure") || action.type.includes("Error");
}

function sanitizeAction(action: Action): Record<string, unknown> {
	const { type, ...rest } = action;
	const keys = Object.keys(rest);
	if (keys.length === 0) return {};
	const sanitized: Record<string, unknown> = {};
	for (const key of keys) {
		sanitized[key] = truncate(rest[key]);
	}
	return sanitized;
}

export function sentryMetaReducer<S>(reducer: ActionReducer<S>): ActionReducer<S> {
	return (state, action) => {
		// Only attach payload data for failure/error actions to reduce noise
		if (isFailureAction(action)) {
			Sentry.addBreadcrumb({
				category: "ngrx.action",
				message: action.type,
				data: sanitizeAction(action),
				level: "warning",
			});
		} else {
			Sentry.addBreadcrumb({
				category: "ngrx.action",
				message: action.type,
				level: "info",
			});
		}

		return reducer(state, action);
	};
}

export const sentryMetaReducers: MetaReducer<unknown>[] = [sentryMetaReducer];
